import { queryWechatAppId, queryWechatOpenId } from '@/api/wechat/wechatAuto'

/**
 * 微信相关方法封装
 * @param {string} adviceCode - 建议码
 * @param {string} category - 分类
 * @param {string} [code] - 微信授权code（获取openId时必填）
 * @param {string} [url] - 页面URL（获取appId时必填）
 * @returns {Object} 包含获取appId和openId的方法
 */
export function useWechat(adviceCode, category, code, url) {
  const getCommonParams = () => ({
    adviceCode,
    category,
  })

  /**
   * 获取微信AppId
   */
  const getWechatAppId = async () => {
    if (!url) {
      throw new Error('获取微信AppId失败：缺少必要参数url')
    }

    const params = {
      ...getCommonParams(),
      url,
    }

    try {
      const res = await queryWechatAppId(params)
      return res
    } catch (error) {
      console.error('获取微信AppId失败：', error)
      throw error // 抛出错误让调用方处理
    }
  }

  /**
   * 获取微信OpenId
   */
  const getWechatOpenId = async () => {
    if (!code || typeof code !== 'string' || code.trim() === '') {
      throw new Error('获取微信OpenId失败：code参数必须是非空字符串')
    }

    const params = {
      ...getCommonParams(),
      code,
    }

    try {
      const res = await queryWechatOpenId(params)
      return res
    } catch (error) {
      console.error('获取微信OpenId失败：', error)
      throw error
    }
  }

  return {
    getWechatAppId,
    getWechatOpenId,
  }
}
